<div *ngIf="display" class="title-box">
    <h1 *ngIf="isPageHeading && h1StyleMode === 'sr-only'" class="sr-only">{{ title }}</h1>
    <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" [innerHTML]="title | safeHtml" class="banner-title"></h1>
    <h2 *ngIf="!isPageHeading" [innerHTML]="title | safeHtml" class="banner-title"></h2>
    <div *ngIf="titleUnderline" class="title-underline"></div>
    <p *ngIf="subtitle" class="banner-subtitle" [innerHTML]="subtitle | safeHtml"></p>
</div>
